import { pxToRem, theme } from '@pocketlaw/tetris';
import { motion } from 'motion/react';
import styled from 'styled-components';
export const StickyContainer = styled(motion.div).attrs((p) => ({
    animate: {
        opacity: p.$show ? 1 : 0,
        y: p.$show ? 0 : pxToRem(8),
        scale: p.$show ? 1 : 0.9,
        display: p.$show ? 'block' : 'none',
    },
    initial: false,
})) `
  pointer-events: none;
  position: ${(p) => (p.$sticky ? 'sticky' : 'absolute')};
  left: 0;
  right: 0;
  bottom: ${theme.spacing['2xl']};
`;
export const InnerContainer = styled.div `
  pointer-events: all;
  display: flex;
  margin: 0 auto;
  width: ${(p) => (p.$stretch ? '100%' : 'fit-content')};
  align-items: center;
  gap: ${theme.spacing.md};
  padding: ${theme.spacing.lg};
  border-radius: ${theme.borderRadius.lg};
  background-color: ${theme.semantic.surface.inverse};
  box-shadow: ${theme.dropShadow[300]};
`;
